import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDocument = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 19.3177C5 20.5132 5.97555 21.4824 7.17895 21.4824H17.2021C18.4055 21.4824 19.3811 20.5132 19.3811 19.3177V8.00708C19.379 7.86433 19.3203 7.72817 19.2176 7.62825L13.3617 2.13531C13.2652 2.04731 13.1386 1.99896 13.0076 2.00002H7.17895C5.97555 2.00002 5 2.96919 5 4.16472V19.3177ZM13.5524 3.7859L17.4745 7.4659H14.0971C13.9503 7.4738 13.8071 7.41932 13.7032 7.31607C13.5993 7.21282 13.5444 7.07053 13.5524 6.92472V3.7859ZM7.17895 3.08237C6.57725 3.08237 6.08947 3.56696 6.08947 4.16472V19.3177C6.08947 19.9154 6.57725 20.4 7.17895 20.4H17.2021C17.8038 20.4 18.2916 19.9154 18.2916 19.3177V8.54825H14.0971C13.6614 8.55565 13.2414 8.38698 12.9333 8.08089C12.6252 7.7748 12.4554 7.35754 12.4629 6.92472V3.08237H7.17895Z"
          fill="currentColor"
        />
        <path
          d="M7.83258 14.7988H16.5211C16.822 14.7988 17.0659 14.5566 17.0659 14.2577C17.0659 13.9588 16.822 13.7165 16.5211 13.7165H7.83258C7.53173 13.7165 7.28784 13.9588 7.28784 14.2577C7.28784 14.5566 7.53173 14.7988 7.83258 14.7988Z"
          fill="currentColor"
        />
        <path
          d="M7.83258 11.5518H12.4356C12.7365 11.5518 12.9803 11.3095 12.9803 11.0106C12.9803 10.7117 12.7365 10.4694 12.4356 10.4694H7.83258C7.53173 10.4694 7.28784 10.7117 7.28784 11.0106C7.28784 11.3095 7.53173 11.5518 7.83258 11.5518Z"
          fill="currentColor"
        />
        <path
          d="M7.83258 18.0459H16.5211C16.822 18.0459 17.0659 17.8036 17.0659 17.5047C17.0659 17.2059 16.822 16.9636 16.5211 16.9636H7.83258C7.53173 16.9636 7.28784 17.2059 7.28784 17.5047C7.28784 17.8036 7.53173 18.0459 7.83258 18.0459Z"
          fill="currentColor"
        />
      </svg>
    </IconBase>
  );
};

SvgDocument.displayName = 'SvgDocument';
export default SvgDocument;
